import Toastify from "toastify-js";
import "toastify-js/src/toastify.css";
import { showDialogOverlay, hideDialogOverlay } from "../../../../utils/dialogOverlay.js";
import { getTodayLocalDateInputValue } from "../../../../utils/dateOnly.js";
import { apiBaseUrl } from "./api.js";
import { renderDemirbasGrid } from "../../demirbasGrid.js";
import { uiState } from "../../../../state/uiState.js";
import IMask from "imask";
import { DemirbasDraft } from "./DemirbasDraft.js";
import * as FilePond from "filepond";
import "filepond/dist/filepond.css";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";

import FilePondPluginImageExifOrientation from "filepond-plugin-image-exif-orientation";
import FilePondPluginFileValidateSize from "filepond-plugin-file-validate-size";

import {
	initFaturaSection,
	faturaInstances,
	resetFaturaSection,
	setFaturaAmortismanDefinitions,
} from "./faturaSection.js";
import { initCreateDialogDropdowns, resetCreateZimmetInfoCard } from "./createDropdowns.js";
import { postJson } from "./api.js"; // en üste ekle
FilePond.registerPlugin(
	FilePondPluginImagePreview,
	FilePondPluginImageExifOrientation,
	FilePondPluginFileValidateSize,
	FilePondPluginFileValidateType,
);
function showToast(message, type = "success", inDialog = true) {
	Toastify({
		text: message,
		duration: 3000,
		gravity: "top",
		position: "right",
		stopOnFocus: true,
		selector: inDialog ? document.querySelector("#createDialog") : document.body,
		style: {
			background: type === "success" ? "#22c55e" : "#ee4447",
			borderRadius: "8px",
			fontSize: "14px",
			fontWeight: "500",
			zIndex: "99999",
			position: "fixed",
		},
	}).showToast();
}
let didBindCreateDialog = false;
let createDialogExpiryTimer = null;
let createDialogDraftDeadline = null;
let createDialogDraftTicker = null;
const BULK_CREATE_MIN = 2;
const BULK_CREATE_MAX = 250;

function clearCreateDialogExpiryTimer() {
	if (createDialogExpiryTimer) {
		clearTimeout(createDialogExpiryTimer);
		createDialogExpiryTimer = null;
	}
}

function clearCreateDraftTicker() {
	if (createDialogDraftTicker) {
		clearInterval(createDialogDraftTicker);
		createDialogDraftTicker = null;
	}
}

function hasCreateDraftUploads(createDialog) {
	const imagePath = createDialog.querySelector("#create_urun_gorsel_path")?.value || "";
	if (imagePath.startsWith("/uploads/_drafts/")) return true;
	return [...createDialog.querySelectorAll(".fatura-pdf-path")].some((input) =>
		(input.value || "").startsWith("/uploads/_drafts/"),
	);
}

function renderCreateDraftTimer(createDialog) {
	const pill = createDialog.querySelector(".draft-timer-pill");
	const textEl = createDialog.querySelector(".draft-timer-text");
	if (!pill || !textEl || !createDialogDraftDeadline) return;

	const remainingMs = Math.max(0, createDialogDraftDeadline - Date.now());
	const remainingSeconds = Math.ceil(remainingMs / 1000);
	const minutes = String(Math.floor(remainingSeconds / 60)).padStart(2, "0");
	const seconds = String(remainingSeconds % 60).padStart(2, "0");

	pill.hidden = false;
	pill.classList.toggle("is-warning", remainingSeconds <= 5 * 60);
	textEl.textContent = `${minutes}:${seconds}`;
}

function resetCreateDraftTimerUi(createDialog) {
	const pill = createDialog.querySelector(".draft-timer-pill");
	if (pill) {
		pill.hidden = true;
		pill.classList.remove("is-warning");
	}
	createDialogDraftDeadline = null;
	clearCreateDraftTicker();
}

function ensureCreateDraftTimer(createDialog) {
	if (!createDialog.open) return;
	if (!hasCreateDraftUploads(createDialog)) {
		clearCreateDialogExpiryTimer();
		resetCreateDraftTimerUi(createDialog);
		return;
	}

	if (!createDialogDraftDeadline) {
		createDialogDraftDeadline = Date.now() + 15 * 60 * 1000;
		clearCreateDialogExpiryTimer();
		createDialogExpiryTimer = setTimeout(() => {
			if (!createDialog.open) return;
			showToast("Taslak suresi doldu.", "error", false);
			createDialog.close();
		}, 15 * 60 * 1000);

		clearCreateDraftTicker();
		createDialogDraftTicker = setInterval(() => {
			if (!createDialog.open || !createDialogDraftDeadline) return;
			renderCreateDraftTimer(createDialog);
		}, 1000);
	}

	renderCreateDraftTimer(createDialog);
}

function bindSerialRepeatUx(createDialog) {
	const serialRadio = createDialog.querySelector("#create_serial_mode_serial");
	const repeatRadio = createDialog.querySelector("#create_serial_mode_repeat");
	const serialInput = createDialog.querySelector("#create_seri_numarasi");
	const countInput = createDialog.querySelector("#create_seri_tekrar_adedi");
	const rows = [...createDialog.querySelectorAll(".serial-mode-row")];
	if (!serialRadio || !repeatRadio || !serialInput || !countInput || serialRadio.dataset.bound) return;

	serialRadio.dataset.bound = "true";

	const sync = () => {
		const repeatMode = repeatRadio.checked;
		serialInput.disabled = repeatMode;
		countInput.disabled = !repeatMode;
		if (repeatMode) serialInput.value = "";
		if (!repeatMode) countInput.value = "";
		rows.forEach((row) => {
			row.classList.toggle("is-active", row.dataset.mode === (repeatMode ? "repeat" : "serial"));
			row.classList.toggle("is-inactive", row.dataset.mode !== (repeatMode ? "repeat" : "serial"));
		});
	};

	serialRadio.addEventListener("change", sync);
	repeatRadio.addEventListener("change", sync);
	countInput.addEventListener("input", () => {
		countInput.value = countInput.value.replace(/\D+/g, "");
	});
	countInput.addEventListener("blur", () => {
		if (!countInput.value) return;
		const value = Number.parseInt(countInput.value, 10);
		if (!Number.isInteger(value)) return;
		countInput.value = String(Math.min(BULK_CREATE_MAX, Math.max(BULK_CREATE_MIN, value)));
	});
	rows.forEach((row) => {
		if (row.dataset.bound) return;
		row.dataset.bound = "true";
		row.addEventListener("click", () => {
			const isRepeat = row.dataset.mode === "repeat";
			if (isRepeat) repeatRadio.checked = true;
			else serialRadio.checked = true;
			sync();
		});
	});

	sync();
}

function resetSerialRepeatUx(createDialog) {
	const serialRadio = createDialog.querySelector("#create_serial_mode_serial");
	const repeatRadio = createDialog.querySelector("#create_serial_mode_repeat");
	const serialInput = createDialog.querySelector("#create_seri_numarasi");
	const countInput = createDialog.querySelector("#create_seri_tekrar_adedi");
	if (serialRadio) serialRadio.checked = true;
	if (repeatRadio) repeatRadio.checked = false;
	if (serialInput) serialInput.disabled = false;
	if (countInput) {
		countInput.value = "";
		countInput.disabled = true;
	}
}

function getCreateModeSelection(createDialog) {
	const repeatMode = Boolean(createDialog.querySelector("#create_serial_mode_repeat")?.checked);
	const rawCount = String(createDialog.querySelector("#create_seri_tekrar_adedi")?.value || "").replace(/\D+/g, "");
	const parsedCount = Number.parseInt(rawCount, 10);
	return {
		mode: repeatMode ? "bulk" : "single",
		count: repeatMode ? parsedCount : 1,
	};
}

function validateCreateModeSelection(createDialog) {
	const { mode, count } = getCreateModeSelection(createDialog);
	if (mode !== "bulk") return null;
	if (!Number.isInteger(count) || count < BULK_CREATE_MIN || count > BULK_CREATE_MAX) {
		return `Coklu giris icin adet ${BULK_CREATE_MIN} ile ${BULK_CREATE_MAX} arasinda olmalidir.`;
	}
	return null;
}

function buildSerialModeCardHtml(prefix) {
	return `
		<div class="serial-mode-card">
			<div class="serial-mode-info">
				<span class="material-icons">info</span>
				<span>Demirbaş formunun tekli mi çoklu mu giriş modunda olacağını seçiniz.</span>
			</div>
			<div class="serial-mode-row is-active" data-mode="serial">
				<label class="serial-mode-radio" for="${prefix}_serial_mode_serial">
					<input id="${prefix}_serial_mode_serial" type="radio" name="${prefix}_serial_mode" checked />
					<span>Tekli Giriş</span>
				</label>
				<div class="serial-mode-help">Tekli ise seri numarası giriniz.</div>
				<input id="${prefix}_seri_numarasi" class="form-input serial-mode-input" type="text" placeholder="Seri numarası" maxlength="150" />
			</div>
			<div class="serial-mode-row is-inactive" data-mode="repeat">
				<label class="serial-mode-radio" for="${prefix}_serial_mode_repeat">
					<input id="${prefix}_serial_mode_repeat" type="radio" name="${prefix}_serial_mode" />
					<span>Çoklu Giriş</span>
				</label>
				<div class="serial-mode-help">Çoklu ise tekrar adedini giriniz.</div>
				<input id="${prefix}_seri_tekrar_adedi" class="form-input serial-mode-input serial-mode-count" type="text" inputmode="numeric" placeholder="Adet" disabled />
			</div>
		</div>`;
}

function normalizeSerialModeCardContent(createDialog) {
	const serialHelp = createDialog.querySelector('.serial-mode-row[data-mode="serial"] .serial-mode-help');
	if (serialHelp) {
		serialHelp.textContent = "Seri numarasi zorunlu degildir. Minimum 4 karakter.";
	}

	const repeatHelp = createDialog.querySelector('.serial-mode-row[data-mode="repeat"] .serial-mode-help');
	if (repeatHelp) {
		repeatHelp.textContent = `Seri numarasiz toplu kayit icin adet giriniz. Adet ${BULK_CREATE_MIN} ile ${BULK_CREATE_MAX} arasinda olabilir.`;
	}

	const countInput = createDialog.querySelector("#create_seri_tekrar_adedi");
	if (countInput) {
		countInput.maxLength = 3;
		countInput.placeholder = `Adet (${BULK_CREATE_MIN}-${BULK_CREATE_MAX})`;
	}
}

function ensureDraftUploadNotes(dialog) {
	dialog.querySelectorAll(".column-container.create-gorsel").forEach((field) => {
		if (field.querySelector(".draft-upload-note")) return;
		const container = field.querySelector(".gorsel-container");
		container?.insertAdjacentHTML(
			"afterend",
			`<div class="draft-upload-note">
				<span class="material-icons">info</span>
				<span>Yüklenen dosyalar önce taslak olarak tutulur. Kaydetmezseniz 15 dakika sonra otomatik silinir.</span>
			</div>`,
		);
	});
}

function applyCreateDialogVisualParity(createDialog) {
	const serialField = createDialog.querySelector(".column-container.field.seri-numarasi");
	if (serialField) {
		const oldInfo = serialField.querySelector(".info");
		const oldInfoHtml = oldInfo?.outerHTML
			|| `<span class="info" data-focus="(4-150 karakter, A-Z, 0-9, -)" data-invalid="Seri numarası 4-150 karakter olmalı. Sadece A-Z, 0-9 ve '-' kullanın."></span>`;
		serialField.innerHTML = `<label>Giriş Modu:</label>${buildSerialModeCardHtml("create")}${oldInfoHtml}`;
	}

	normalizeSerialModeCardContent(createDialog);
	const pillText = createDialog.querySelector(".draft-timer-text");
	if (pillText) pillText.textContent = "15:00";
	ensureDraftUploadNotes(createDialog);
}

function initCreateSerialMask(createDialog) {
	const snEl = createDialog.querySelector("#create_seri_numarasi");
	if (!snEl || snEl._mask) return;

	const mask = IMask(snEl, {
		mask: /^[A-Z0-9-]*$/,
		prepare: (s) => s.toUpperCase().replace(/\s+/g, ""),
	});
	snEl._mask = mask;

	snEl.addEventListener("blur", () => {
		const len = snEl.value.length;
		if (len === 0) {
			snEl.setCustomValidity("");
			return;
		}
		snEl.setCustomValidity(len < 4 ? "Seri numarası en az 4 karakter olmalı." : "");
	});
}

function ensureCreateDialogStaticParity(createDialog) {
	if (!createDialog.querySelector(".draft-timer-pill")) {
		const header = createDialog.querySelector(".create-dialog-header");
		header?.insertAdjacentHTML(
			"afterend",
			`
			<div class="draft-timer-pill" hidden>
				<span class="material-icons">schedule</span>
				<span class="draft-timer-text">Taslak dosyalar 15 dk tutulur.</span>
			</div>`,
		);
	}

	const serialField = createDialog.querySelector(".column-container.field.seri-numarasi");
	if (!serialField || serialField.querySelector(".serial-mode-card")) return;

	const oldInfo = serialField.querySelector(".info");
	const oldInfoHtml = oldInfo?.outerHTML
		|| `<span class="info" data-focus="(4-150 karakter, A-Z, 0-9, -)" data-invalid="Seri numarası 4-150 karakter olmalı. Sadece A-Z, 0-9 ve '-' kullanın."></span>`;

	serialField.innerHTML = `
		<label>Seri Girişi:</label>
		<div class="serial-mode-card">
			<div class="serial-mode-row">
				<label class="serial-mode-radio" for="create_serial_mode_serial">
					<input id="create_serial_mode_serial" type="radio" name="create_serial_mode" checked />
					<span>Seri Numarası</span>
				</label>
				<input id="create_seri_numarasi" class="form-input" type="text" placeholder="Seri numarası" maxlength="150" />
			</div>
			<div class="serial-mode-row">
				<label class="serial-mode-radio" for="create_serial_mode_repeat">
					<input id="create_serial_mode_repeat" type="radio" name="create_serial_mode" />
					<span>Tekrar Adedi</span>
				</label>
				<input id="create_seri_tekrar_adedi" class="form-input serial-mode-count" type="text" inputmode="numeric" placeholder="Adet" disabled />
			</div>
		</div>
		${oldInfoHtml}
	`;

	createDialog.querySelector(".column-container.serial-repeat-spacer")?.remove();
	normalizeSerialModeCardContent(createDialog);
}

function ensureCreateDialog() {
	if (document.getElementById("createDialog")) return;
	document.body.insertAdjacentHTML(
		"beforeend",
		`
<dialog id="createDialog" class="create-dialog">
    <div class="edit-loading-overlay" hidden>
        <div class="edit-loading-spinner"></div>
        <span class="edit-loading-text">Yükleniyor...</span>
    </div>
    <form method="dialog" novalidate class="create-dialog-container">
        <div class="create-dialog-header">
            <h4>Demirbaş Ekle</h4>
        </div>
        <div class="draft-timer-pill" hidden>
            <span class="material-icons">schedule</span>
            <span class="draft-timer-text">Taslak dosyalar 15 dk tutulur.</span>
        </div>
        <div class="create-dialog-content">
            <div class="temel-bilgiler section">
                <div class="section-1-header"><h5>Temel Bilgiler</h5></div>
                <div class="section-1-content">
                    <div class="column-container field">
                        <label for="create_departman">Departman:</label>
                        <select id="create_departman" class="form-select" name="departman" required>
                            <option value="" selected>Departman seçiniz</option>
                        </select>
                        <span class="info" data-required="Bu alan zorunludur." data-focus="Departman seçiniz." data-invalid="Geçerli bir departman seçmelisiniz."></span>
                    </div>
                    <div class="column-container field">
                        <label for="create_urun_grubu">Ürün Grubu:</label>
                        <select id="create_urun_grubu" class="form-select" name="urun_grubu" required>
                            <option value="" selected>Ürün grubu seçiniz</option>
                        </select>
                        <span class="info" data-required="Bu alan zorunludur." data-focus="Ürün grubu seçiniz." data-invalid="Geçerli bir ürün grubu seçmelisiniz."></span>
                    </div>
                    <div class="column-container field">
                        <label for="create_urun_alt_grubu">Ürün Alt Grubu:</label>
                        <select id="create_urun_alt_grubu" class="form-select" name="urun_alt_grubu" required>
                            <option value="" selected>Ürün alt grubu seçiniz</option>
                        </select>
                        <span class="info" data-required="Bu alan zorunludur." data-focus="Ürün alt grubu seçiniz." data-invalid="Geçerli bir ürün alt grubu seçmelisiniz."></span>
                    </div>
                    <div class="column-container field">
                        <label for="create_urun_cinsi">Ürün Cinsi:</label>
                        <select id="create_urun_cinsi" class="form-select" name="urun_cinsi" required>
                            <option value="" selected>Ürün cinsi seçiniz</option>
                        </select>
                        <span class="info" data-required="Bu alan zorunludur." data-focus="Ürün cinsi seçiniz." data-invalid="Geçerli bir ürün cinsi seçmelisiniz."></span>
                    </div>
                    <div class="column-container field">
                        <label for="create_marka">Marka:</label>
                        <select id="create_marka" class="form-select" name="marka" required>
                            <option value="" selected>Marka seçiniz</option>
                        </select>
                        <span class="info" data-required="Bu alan zorunludur." data-focus="Marka seçiniz." data-invalid="Geçerli bir marka seçmelisiniz."></span>
                    </div>
                    <div class="column-container field create-model">
                        <label for="create_model">Model:</label>
                        <select id="create_model" class="form-select" name="model" required>
                            <option value="" selected>Model seçiniz</option>
                        </select>
                        <span class="info" data-required="Bu alan zorunludur." data-focus="Model seçiniz." data-invalid="Geçerli bir model seçmelisiniz."></span>
                    </div>
                    <div class="column-container field seri-numarasi">
                        <label for="create_seri_numarasi">Seri Numarası:</label>
                        <input id="create_seri_numarasi" class="form-input" type="text" placeholder="Seri numarası" maxlength="150" />
                        <span class="info" data-focus="(4-150 karakter, A-Z, 0-9, -)" data-invalid="Seri numarası 4-150 karakter olmalı. Sadece A-Z, 0-9 ve '-' kullanın."></span>
                    </div>
                    <div class="column-container serial-repeat-spacer">
                        <span></span>
                        <div class="serial-repeat-ux">
                            <label class="serial-repeat-toggle">
                                <input id="create_seri_numarasi_yok" type="checkbox" />
                                <span>Seri numarası yok</span>
                            </label>
                            <input
                                id="create_seri_tekrar_adedi"
                                class="form-input serial-repeat-count"
                                type="text"
                                inputmode="numeric"
                                placeholder="Tekrar adedi"
                                disabled
                            />
                        </div>
                    </div>
                    <div class="column-container field create-aciklama">
                        <label for="create_aciklama">Açıklama:</label>
                        <textarea id="create_aciklama" class="form-textarea" placeholder="Açıklama yazabilirsiniz" maxlength="500"></textarea>
                        <span class="info" data-focus="Maksimum 500 karakter." data-invalid="Açıklama 500 karakteri geçemez."></span>
                    </div>
                </div>
            </div>
            <div class="fatura-bilgiler section">
                <div class="section-1-header"><h5>Fatura Bilgileri</h5></div>
                <div class="section-1-content" id="faturaList"></div>
                <div class="add-new-fatura">
                    <button class="btn-add" type="button">Yeni Fatura Ekle</button>
                </div>
            </div>
            <div class="zimmet-lokasyon-bilgiler section">
                <div class="section-1-header"><h5>Zimmet &amp; Lokasyon</h5></div>
                <div class="section-1-content">
                    <div class="column-container field create-urun-durumu">
                        <label for="create_urun_durumu">Ürün Durumu:</label>
                        <select id="create_urun_durumu" class="form-select" name="urun_durumu" required>
                            <option value="" selected>Ürün durumu seçiniz</option>
                        </select>
                        <span class="info" data-required="Bu alan zorunludur." data-focus="Ürün durumu seçiniz." data-invalid="Geçerli bir ürün durumu seçmelisiniz."></span>
                    </div>
                    <div class="column-container field create-zimmet-durumu">
                        <label for="create_zimmet_durumu">Zimmet Durumu:</label>
                        <select id="create_zimmet_durumu" class="form-select" name="zimmet_durumu" required>
                            <option value="" selected>Zimmet durumu seçiniz</option>
                        </select>
                        <span class="info" data-required="Bu alan zorunludur." data-focus="Zimmet durumu seçiniz." data-invalid="Geçerli bir zimmet durumu seçmelisiniz."></span>
                    </div>
                    <div class="column-container field create-zimmetlenen-kisi">
                        <label for="create_zimmetlenen_kisi">Zimmetlenen Kişi:</label>
                        <select id="create_zimmetlenen_kisi" class="form-select" name="zimmet_zimmetlenen_kisi" required>
                            <option value="" selected>Zimmetlenen kişi seçiniz</option>
                        </select>
                        <span class="info" data-required="Bu alan zorunludur." data-focus="Zimmetlenen kişi seçiniz." data-invalid="Geçerli bir zimmetlenen kişi seçmelisiniz."></span>
                    </div>
                   <div class="info-card-yeni" id="zimmetInfoCard">
    <div class="info-card-yeni-satir">
        <div class="info-card-yeni-etiket">T.C. Kimlik No</div>
        <div class="info-card-yeni-deger info-card-yeni-deger--mono zimmet-tc-deger">—</div>
    </div>
    <div class="info-card-yeni-satir">
        <div class="info-card-yeni-etiket">Ünvan</div>
        <div class="info-card-yeni-deger zimmet-unvan-deger">—</div>
    </div>
    <div class="info-card-yeni-satir">
        <div class="info-card-yeni-etiket">Departman</div>
        <div class="info-card-yeni-deger zimmet-departman-deger">—</div>
    </div>
</div>
                    <div class="column-container field create-zimmet-tarihi">
                        <label for="create_zimmet_tarihi">Zimmet Tarihi:</label>
                        <input id="create_zimmet_tarihi" class="form-input" type="date" required />
                        <span class="info" data-invalid="Geçerli bir zimmet tarihi giriniz."></span>
                    </div>
                    <div class="column-container field">
                        <label for="create_lokasyon">Lokasyon:</label>
                        <select id="create_lokasyon" class="form-select" name="create_lokasyon" required>
                            <option value="" selected>Lokasyon seçiniz.</option>
                        </select>
                        <span class="info" data-required="Bu alan zorunludur." data-focus="Lokasyon seçiniz." data-invalid="Geçerli bir lokasyon seçmelisiniz."></span>
                    </div>
                    <div class="column-container field">
                        <label for="create_oda">Oda:</label>
                        <select id="create_oda" class="form-select" name="create_oda" required>
                            <option value="" selected>Oda seçiniz.</option>
                        </select>
                        <span class="info" data-required="Bu alan zorunludur." data-focus="Oda seçiniz." data-invalid="Geçerli bir oda seçmelisiniz."></span>
                    </div>
                    <div class="column-container field">
                        <label for="create_yer">Yer:</label>
                        <select id="create_yer" class="form-select" name="create_yer" required>
                            <option value="" selected>Yer seçiniz.</option>
                        </select>
                        <span class="info" data-required="Bu alan zorunludur." data-focus="Yer seçiniz." data-invalid="Geçerli bir yer seçmelisiniz."></span>
                    </div>
                </div>
            </div>
            <div class="urun-gorsel section">
                <div class="section-1-header"><h5>Ürün Görsel</h5></div>
                <div class="section-1-content">
                    <div class="column-container create-gorsel">
                        <label>Ürün Resmi</label>
                        <div class="gorsel-container">
                            <input type="file" class="filepond" />
                            <input type="hidden" id="create_urun_gorsel_path" value="" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="create-dialog-buttons">
            <button type="button" class="create-cancel">İptal</button>
            <button type="submit" class="create-save">Kaydet</button>
        </div>
    </form>
</dialog>`,
	);
}

export function initCreateDialog() {
	ensureCreateDialog();
	const createDialog = document.querySelector("#createDialog");
	if (!createDialog) return;
	ensureCreateDialogStaticParity(createDialog);

	// initCreateDialog yanlışlıkla 2 kere çağrılırsa listener şişmesin
	if (didBindCreateDialog) return;
	didBindCreateDialog = true;

	// --- open/close (tek listener) ---
	document.body.addEventListener("click", async (e) => {
		if (e.target.closest(".demirbas-ekle")) {
			ensureCreateDialogStaticParity(createDialog);
			createDialog.showModal();
			createDialog.scrollTop = 0;
			clearCreateDialogExpiryTimer();
			resetCreateDraftTimerUi(createDialog);

			showDialogOverlay(createDialog, "Yükleniyor...");
			await new Promise((r) => setTimeout(r, 350));
			try {
				const dropdownData = await initCreateDialogDropdowns(createDialog);
				setFaturaAmortismanDefinitions(createDialog, dropdownData?.amortismanTanimlari || []);
			} catch (err) {
				console.error("❌ Create dropdown load hatası:", err);
			} finally {
				hideDialogOverlay();
			}
		}

		if (e.target.closest(".create-dialog-close") || e.target.closest(".create-cancel")) {
			createDialog.close();
		}
	});

	// --- Demirbaş görsel FilePond (tekil alan) ---
	const demirbasImageInput = createDialog.querySelector(".urun-gorsel input.filepond");
	const urunGorselPathHidden = createDialog.querySelector("#create_urun_gorsel_path");

	// Gorsel dosya seçildi mi? (getFiles() yerine event ile takip — XHR'a dokunmaz)
	let gorselFileAdded = false;

	if (demirbasImageInput && !demirbasImageInput._pond) {
		// payload için server path burada tutulacak
		demirbasImageInput.dataset.uploadedPath = "";
		if (urunGorselPathHidden) urunGorselPathHidden.value = "";

		const pond = FilePond.create(demirbasImageInput, {
			allowMultiple: false,
			maxFiles: 1,
			maxFileSize: "10MB",
			imagePreviewHeight: 270,

			acceptedFileTypes: ["image/png", "image/jpeg", "image/webp"],

			server: {
				process: {
					url: `${apiBaseUrl}/upload/urun-gorsel`,
					method: "POST",
					onload: (responseText) => {
						const data = JSON.parse(responseText);

						// ör: { ok:true, filePath:"/uploads/...", serverId:"/uploads/..." }
						const filePath = data.filePath || data.path || "";
						const serverId = data.serverId || filePath;

						demirbasImageInput.dataset.uploadedPath = filePath;
						if (urunGorselPathHidden) urunGorselPathHidden.value = filePath;

						return serverId; // FilePond revert için bunu kullanır
					},
					onerror: (responseText) => {
						try {
							const data = JSON.parse(responseText);
							return data.error || "Upload başarısız";
						} catch {
							return "Upload başarısız";
						}
					},
				},

				revert: (serverId, load, error) => {
					fetch(`${apiBaseUrl}/upload/revert`, {
						method: "DELETE",
						headers: { "Content-Type": "application/json" },
						body: JSON.stringify({ serverId }),
					})
						.then(async (res) => {
							if (!res.ok) throw new Error("Revert başarısız");

							demirbasImageInput.dataset.uploadedPath = "";
							if (urunGorselPathHidden) urunGorselPathHidden.value = "";

							load();
						})
						.catch((err) => {
							console.error("❌ Ürün görsel revert hatası:", err);
							error("Revert başarısız");
						});
				},
			},
		});

		pond.on("addfile", () => {
			gorselFileAdded = true;
		});
		pond.on("removefile", () => {
			gorselFileAdded = false;
			demirbasImageInput.dataset.uploadedPath = "";
			if (urunGorselPathHidden) urunGorselPathHidden.value = "";
			createDialog.dispatchEvent(new CustomEvent("draft-upload-change"));
		});
		pond.on("processfile", (err, file) => {
			if (err) return;
			const filePath = file?.serverId || "";
			demirbasImageInput.dataset.uploadedPath = filePath;
			if (urunGorselPathHidden) urunGorselPathHidden.value = filePath;
			createDialog.dispatchEvent(new CustomEvent("draft-upload-change"));
		});
		pond.on("processfilerevert", () => {
			gorselFileAdded = false;
			demirbasImageInput.dataset.uploadedPath = "";
			if (urunGorselPathHidden) urunGorselPathHidden.value = "";
			createDialog.dispatchEvent(new CustomEvent("draft-upload-change"));
		});

		demirbasImageInput._pond = pond;
	}

	// --- Seri No mask + validity (tekil alan) ---
	initCreateSerialMask(createDialog);

	// --- Zimmet tarihi: gelecek tarih engellensin ---
	const zimmetTarihEl = createDialog.querySelector("#create_zimmet_tarihi");
	if (zimmetTarihEl) {
		zimmetTarihEl.max = getTodayLocalDateInputValue();
	}

	// ✅ fatura section init (ilk kartı kurar + add/delete bağlar)
	initFaturaSection(createDialog);
	ensureCreateDialogStaticParity(createDialog);
	applyCreateDialogVisualParity(createDialog);
	initCreateSerialMask(createDialog);
	bindSerialRepeatUx(createDialog);
	createDialog.addEventListener("draft-upload-change", () => ensureCreateDraftTimer(createDialog));

	// --- SUBMIT: payload üret + console'a bas ---
	const form = createDialog.querySelector("form.create-dialog-container");

	function resetCreateDialog() {
		form?.reset();
		demirbasImageInput?._pond?.removeFiles();
		createDialog.querySelector("#create_seri_numarasi")?.setCustomValidity("");
		resetFaturaSection(createDialog);
		resetSerialRepeatUx(createDialog);
		resetCreateDraftTimerUi(createDialog);
		resetCreateZimmetInfoCard(createDialog);
	}

	// Dialog kapanınca sıfırla
	createDialog.addEventListener("close", () => {
		clearCreateDialogExpiryTimer();
		resetCreateDraftTimerUi(createDialog);
		delete createDialog.dataset.submitted;
		resetCreateDialog();
	});

	if (form && !form._payloadBound) {
		form._payloadBound = true;

		form.addEventListener("submit", async (e) => {
			e.preventDefault();

			// data-submitted → CSS'de untouched invalid alanları göster
			createDialog.dataset.submitted = "true";

			// HTML required alanlar geçerli mi?
			const formValid = form.checkValidity();

			// Fatura PDF: her kart için upload tamamlanmış olmalı
			const faturaInstList = [...faturaInstances.values()];
			const faturaHazirDegil = faturaInstList.some((inst) => {
				if (!inst.pond) return true;
				if (!inst.hasFile) return true; // dosya seçilmedi
				const hidden = inst.root.querySelector(".fatura-pdf-path");
				return !hidden?.value; // yükleme henüz bitmedi
			});

			// Görsel opsiyonel — dosya seçildiyse upload tamamlanmış olmalı
			// gorselFileAdded event-tabanlı takip (getFiles() XHR hatası veriyordu)
			const gorselHazirDegil = gorselFileAdded && !urunGorselPathHidden?.value;

			if (!formValid) {
				showToast("Lütfen tüm zorunlu alanları doldurunuz.", "error");
				form.querySelector(":invalid")?.scrollIntoView({
					behavior: "smooth",
					block: "center",
				});
				return;
			}

			if (faturaHazirDegil) {
				showToast("Her fatura için PDF yüklenmelidir.", "error");
				return;
			}

			if (gorselHazirDegil) {
				showToast("Görsel yüklenmesi tamamlanmadı, lütfen bekleyiniz.", "error");
				return;
			}
			const modeError = validateCreateModeSelection(createDialog);
			if (modeError) {
				showToast(modeError, "error");
				createDialog.querySelector("#create_seri_tekrar_adedi")?.focus();
				return;
			}

			const { mode, count } = getCreateModeSelection(createDialog);
			const overlayText = mode === "bulk"
				? `${count} demirbas olusturuluyor. Bu islem birkac saniye surebilir.`
				: "Kaydediliyor...";
			showDialogOverlay(createDialog, overlayText);
			await new Promise((r) => setTimeout(r, 350));
			try {
				// 1. payload üret
				const draft = new DemirbasDraft(createDialog);
				const payload = draft.toPayload();
				console.log("📦 PAYLOAD:", JSON.stringify(payload, null, 2));
				console.table(payload.faturalar);
				// 2. kaydet
				const result = await postJson("/demirbas", payload);

				console.log("✅ Kaydedildi:", result.demirbas_id);
				const createdCount = Number(result?.created_count || 1);
				const successText = createdCount > 1
					? `${createdCount} demirbas basariyla olusturuldu.`
					: "Demirbas basariyla olusturuldu.";
				showToast(successText, "success", false);
				createDialog.close();
				const refreshUrl = uiState.demirbas.lastSearchUrl ?? `${apiBaseUrl}/demirbas`;
				renderDemirbasGrid({
					url: refreshUrl,
					paginationLimit: uiState.demirbas.paginationLimit,
				});
			} catch (err) {
				console.error("❌ Submit hatası:", err);
				showToast("Kayıt sırasında hata oluştu.", "error");
			} finally {
				hideDialogOverlay();
			}
		});
	}
}
